export enum AvailableComponentsURLs {
  'customerProfile' = 0,
  'selectSolution',
  'PPSIPTRUNK',
  'PPHosted',
  'datasim',
  'mobile',
  'pfBundle',
  'threeCX',
  'msTeams',
  'operator-connect',
  'sbcplus',
  'pfMittel' ,
  'newNumbers',
  'phonePorted',
  'FlatRateSipTrunk',
  'FlatRateHosted',
  'IPworldcom',
  'internet',
  'peoplephoneDevicesDataBase',
  'myDevicesDataBase' ,
  'followUp',
  'offerSummary',
  'management',
  'mydevmgnt',
  'editManagement',
  'editMyDevices'

}



// WEBPACK FOOTER //
// ./src/enumAvailableComponentsURLs.ts